var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgVisible = function SvgVisible(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#visible_svg__a)",
    stroke: "#fff",
    strokeWidth: 0.75,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 16.12c2.35 0 4.25-1.9 4.25-4.25S14.35 7.62 12 7.62s-4.25 1.9-4.25 4.25 1.9 4.25 4.25 4.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.25 12.56c-.27-.32-.48-.58-.62-.77.14-.19.35-.45.62-.77.55-.64 1.33-1.5 2.31-2.35 1.96-1.72 4.6-3.38 7.45-3.38 2.85 0 5.48 1.65 7.45 3.38.97.86 1.76 1.71 2.31 2.35.27.32.48.58.62.77-.14.19-.35.45-.62.77-.55.64-1.33 1.5-2.31 2.35-1.96 1.72-4.6 3.38-7.45 3.38-2.85 0-5.48-1.65-7.45-3.38-.97-.86-1.76-1.71-2.31-2.35v0Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "visible_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgVisible;